import { jsx as _jsx } from "react/jsx-runtime";
import RelationSearch from '../RelationSearch';
export const FilterRelationSearch = ({ item, itemName, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(RelationSearch, { onChange: value => {
            var _a, _b;
            setFilter({
                [item]: (_a = value === null || value === void 0 ? void 0 : value.id) !== null && _a !== void 0 ? _a : undefined,
                [itemName]: (_b = value === null || value === void 0 ? void 0 : value.label) !== null && _b !== void 0 ? _b : undefined,
                invoiceStreamId: undefined, // always clear invoiceStreamId because it might have been set when navigated from other screen (eg relation file)
            });
        }, initialSelectedItem: activeFilters[item] && activeFilters[itemName]
            ? { key: activeFilters[item], label: activeFilters[itemName] }
            : undefined })),
});
